import React from 'react'
import {Route, Redirect} from 'react-router'
import {loginPageUrl} from '../functions/auth'
import {checkPermission} from '../functions/permissions'

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    checkPermission(rest.permission)
      ? <Component {...props} />
      : <Redirect to={loginPageUrl} />
  )} />
)

export default ProtectedRoute